import { IBuilding, IProject } from 'spw-redux/modules/projects/types';
import { ProgramSummaryParams } from 'spw-redux/modules/program-summary/types';

export const calculateLevelHeadcount = (
  project: IProject,
  selectedLevels: ProgramSummaryParams
) => {
  let headcount = { architectHeadcount: 0, clientHeadcount: 0 };
  const buildings: { [key: number]: IBuilding } = project.buildings.reduce(
    (map, building) => {
      return {
        ...map,
        [building.id]: building,
      };
    },
    {}
  );

  headcount = selectedLevels.buildingIds.reduce(
    (totalHeadcount, buildingId: number) => {
      return {
        architectHeadcount:
          totalHeadcount?.architectHeadcount +
          (buildings[buildingId]?.headcount?.architect || 0),
        clientHeadcount:
          totalHeadcount?.clientHeadcount +
          (buildings[buildingId]?.headcount?.client || 0),
      };
    },
    { architectHeadcount: 0, clientHeadcount: 0 }
  );

  const floors = project.buildings
    .reduce((allFloors, building) => {
      return allFloors.concat(building.floors);
    }, [])
    .reduce((map, floor) => {
      return {
        ...map,
        [floor.id]: floor,
      };
    }, {});

  headcount = selectedLevels.floorIds?.reduce((totalHeadcount, floorId) => {
    return {
      architectHeadcount:
        totalHeadcount?.architectHeadcount +
        (floors[floorId]?.headcount?.architect || 0),
      clientHeadcount:
        totalHeadcount?.clientHeadcount +
        (floors[floorId]?.headcount?.client || 0),
    };
  }, headcount);

  const buildingFloorsHeadcount = selectedLevels.buildingIds?.reduce(
    (totalHeadcount, buildingId) => {
      const building = buildings[buildingId];

      const floorsHeadcount = building?.floors?.reduce(
        (totalFloorsHeadcount, floor) => {
          return {
            ...totalFloorsHeadcount,
            architectHeadcount:
              totalFloorsHeadcount?.architectHeadcount +
              (floors[floor.id]?.headcount?.architect || 0),
            clientHeadcount:
              totalFloorsHeadcount?.clientHeadcount +
              (floors[floor.id]?.headcount?.client || 0),
          };
        },
        { architectHeadcount: 0, clientHeadcount: 0 }
      ) || { architectHeadcount: 0, clientHeadcount: 0 };

      return {
        architectHeadcount:
          totalHeadcount.architectHeadcount +
          floorsHeadcount.architectHeadcount,
        clientHeadcount:
          totalHeadcount.clientHeadcount + floorsHeadcount.clientHeadcount,
      };
    },
    { architectHeadcount: 0, clientHeadcount: 0 }
  );

  headcount.architectHeadcount += buildingFloorsHeadcount.architectHeadcount;
  headcount.clientHeadcount += buildingFloorsHeadcount.clientHeadcount;

  return headcount;
};
